import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader.js";
export default class ModelLoader {
    gltfLoader;
    constructor() {
        const dracoLoader = new DRACOLoader();
        dracoLoader.setDecoderPath("/draco/");
        this.gltfLoader = new GLTFLoader();
        this.gltfLoader.setDRACOLoader(dracoLoader);
    }
    async load(path, name) {
        const gltf = await this.gltfLoader.loadAsync(path);
        const mesh = gltf.scene.getObjectByName(name);
        return mesh.geometry;
    }
}
